/**
 * Higher Education — lightweight error + analytics telemetry.
 *
 * Two exposed helpers on window.HE:
 *   HE.trackError(where, err, context)  → dispatches a `he:error` CustomEvent + pushes to dataLayer
 *   HE.trackEvent(name, data)           → dispatches a `he:event` CustomEvent + pushes to dataLayer
 *
 * Consumers (GTM, Shopify Web Pixels, custom) can subscribe to either the
 * CustomEvents OR the dataLayer entries. Zero cost when no consumer is present.
 */
(function () {
  if (typeof window === 'undefined') return;
  if (window.HE && typeof window.HE.trackError === 'function') return;

  window.HE = window.HE || {};
  window.dataLayer = window.dataLayer || [];

  function safePush(obj) {
    try { window.dataLayer.push(obj); } catch (_e) {}
  }

  function safeDispatch(name, detail) {
    try {
      document.dispatchEvent(new CustomEvent(name, { detail: detail }));
    } catch (_e) {}
  }

  window.HE.trackError = function (where, err, context) {
    var payload = {
      event: 'he_error',
      he_where: where,
      he_message: (err && err.message) || String(err || ''),
      he_context: context || null,
    };
    safePush(payload);
    safeDispatch('he:error', payload);
  };

  window.HE.trackEvent = function (name, data) {
    var payload = Object.assign({ event: name }, data || {});
    safePush(payload);
    safeDispatch('he:event', payload);
  };
})();
